<template>
  <section>
    <div class="content_bg">
      <div :style="borderStyle"></div>
      <div class="content">
        <div class="iphone_frame_section">
          <div class="pc">
            <img
              v-if="type === 'app'"
              style="
                position: absolute;
                border-radius: 39px;
                box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
              "
              width="244"
              src="@/assets/images/iphone_frame.png"
            />
            <video v-if="record.mp4"
              controls
              autoplay
              style="
                left: 12px;
                top: 12px;
                position: absolute;
                border-radius: 20px;
              "
              width="220"
              :src="record.mp4"
            />

            <img v-if="!record.mp4 &&  record.screenshot && record.screenshot.length > 0"
                style="
                  left: 12px;
                  top: 12px;
                  position: absolute;
                  border-radius: 20px;
                "
                width="220"
                :src="record.screenshot[0]"
              />
          </div>
        </div>

        <div class="content_core">
          <div class="app">
            <img class="icon_image" :src="record.icon" />
            <div class="title_group" :style="colorStyle">
              <div class="title">{{ record.name }}</div>
            </div>
          </div>

          <div class="sub_title" :style="colorStyle">
            {{ record.sub_text }}
          </div>

          <div class="desc" v-html="formattedText3"></div>

          <div class="store">
            <a v-if="record.playstore" :href="record.playstore">
              <img width="150" src="@/assets/images/googleplay.png" />
            </a>
            <a v-if="record.appstore" :href="record.appstore">
              <img
                style="margin-left: 15px"
                width="150"
                src="@/assets/images/appstore.png"
              />
            </a>
          </div>
          
          <div class="iphone_frame_section_mobile">
            <div class="mobile">
              <img
                style="
                  left: 0px;
                  top: 0px;
                  position: absolute;
                  border-radius: 39px;
                  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
                "
                width="244"
                src="@/assets/images/iphone_frame.png"
              />
              
              <video v-if="record.mp4 != null"
                controls
                autoplay
                style="
                  left: 12px;
                  top: 12px;
                  position: absolute;
                  border-radius: 20px;
                "
                width="220"
                :src="record.mp4"
              />

              <img v-if="record.mp4 == null && record.screenshot && record.screenshot.length > 0"
                style="
                  left: 12px;
                  top: 12px;
                  position: absolute;
                  border-radius: 20px;
                "
                width="220"
                :src="record.screenshot[0]"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
  
<script>
import Caption from "./Caption.vue";
import CaptionGreen from "./CaptionGreen.vue";
import client from "../client/client";

export default {
  props: ["record", "color", "type"],
  components: {
    Caption,
    CaptionGreen,
  },
  mounted() {},
  data() {
    return {};
  },
  computed: {
    formattedText3: function () {
      return this.record.desc && this.record.desc.replace(/\n/g, "<br>");
    },
    borderStyle() {
      return {
        backgroundColor: this.color,
        opacity: 0.08,
        bottom: 0,
        position: "absolute",
        width: "100%",
        height: "273px",
      };
    },
    colorStyle() {
      return {
        color: this.color,
      };
    },
  },
};
</script>
  
<style scoped>
.content_bg {
  height: 650px;
  display: flex;
  justify-content: center;
  background-color: #ffffff;
  position: relative;
}

.content {
  width: 100vw;
  height: 100%;
  max-width: 1140px;
  display: inline-block;
}

.icon_image {
  width: 100px;
  height: 100px;
  border-radius: 16px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);
}
.title_group {
  display: flex;
  align-items: baseline;
}

.title {
  margin-top: 10px;
  font-size: 52px;
  font-weight: 700;
  margin-left: 26px;
}

.sub_title {
  font-size: 20px;
  font-weight: 700;
  margin-top: 10px;
}

.desc {
  font-size: 17px;
  font-weight: 500;
  color: #777777;
  margin-top: 10px;
}

.content_core {
  margin-left: 50px;
  margin-top: 100px;
  text-align: left;
  width: 1124px;
  max-width: 1124px;
}

.app {
  display: flex;
}

.iphone_frame_section {
  display: flex;
  align-items: center;
  position: absolute;
  width: 400px;
  margin-left: 700px;
  margin-top: 100px;
}

.store {
  position: absolute;
  bottom: 165px;
  display: flex;
  justify-content: space-between;
  width: 315px;
}

@media screen and (max-width: 1440px) {
  .content_bg {
    height: fit-content;
    background-color: #ffffff;
  }

  .content {
    width: 100vw;
    height: fit-content;
    display: inline-block;
    position: relative;
    padding-top: 50px;
    padding-bottom: 50px;
    text-align: center;
  }

  .content_core {
    display: inline-block;
    height: fit-content;
    margin-left: 0px;
    margin-top: 0px;
    text-align: center;
    width: fit-content;
    position: relative;
  }

  .app {
    display: block;
  }

  .iphone_frame_section {
    display: none;
  }

  .iphone_frame_section_mobile {
    width: 244px;
    position: relative;
    height: 500px;
    margin-top: 50px;
    display: inline-block;
  }
  .title_group {
    display: block;
  }

  .title {
    margin-top: 10px;
    font-size: 40px;
    font-weight: 700;
    margin-left: 0px;
  }

  .desc {
    font-size: 17px;
    font-weight: 300;
    margin-top: 10px;
    padding-left: 20px;
    padding-right: 20px;
  }

  .store {
    bottom: 0;
    margin-top: 50px;
    position: relative;
    display: inline-block;
    width: 100vw;
  }
}
</style>
  